<template>
    <div>
        <a class="mr-1" href="javascript:void(1);" @click="changeCredit" v-b-tooltip.hover title="Alterar Créditos">
            <i class="fas fa-edit"></i>
        </a>

        <div v-if="student.credits.length === 0" class="text-danger">
            Não Configurado
        </div>

        <div v-else>
            Qtd: <b>{{ student.credits[0].pivot.qtd }}</b> | Válido até: <b>{{ student.credits[0].pivot.due_date | moment('DD/MM/YYYY') }}</b>
        </div>

        <b-modal
            :id="'credit-' + student.id"
            title="Alterar Créditos"
            centered
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <b-form @submit.stop.prevent="submit">

                    <!-- Field -->
                    <b-form-group
                        label="Aluno">
                        <!-- Input -->
                        <b-form-input
                            :value="student.name"
                            disabled
                        ></b-form-input>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Qtd. de Créditos">

                        <!-- Input -->
                        <b-form-input
                            type="number"
                            :min="0"
                            v-model="form.qtd"
                            :state="hasErrors('qtd', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="qtd" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Data de Vencimento">

                        <!-- Input -->
                        <b-form-datepicker
                            v-model="form.due_date"
                            label-no-date-selected="Nenhuma data selecionada ..."
                            locale="pt-BR">
                        </b-form-datepicker>

                        <!-- Error -->
                        <has-errors :errors="errors" name="due_date" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Alterar Créditos
                    </b-button>

                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['student'],

    data() {
        return {
            hasCredit: false,
            loading: false,
            errors: {},
            form: {
                qtd: null,
                due_date: null,
            }
        }
    },

    created() {
        this.generateForm()
    },

    methods: {

        submit() {
            this.loading = true;
            axios.put('/teacher/students/' + this.student.id + '/credits', this.form)
                .then((result) => {

                    // Callback
                    this.$emit('updated')

                    // Close Modal
                    this.$bvModal.hide('credit-' + this.student.id)

                    // Message
                    this.$toast.success('Créditos alterado com sucesso !')

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        changeCredit() {
            this.generateForm()
            this.$bvModal.show('credit-' + this.student.id)
        },

        generateForm() {
            if (this.student.credits.length > 0) {
                let credit = this.student.credits[0];

                this.form.qtd = credit.pivot.qtd
                this.form.due_date = this.$moment(credit.pivot.due_date).format('YYYY-MM-DD')
            }
        }

    }
}
</script>

<style scoped>

</style>
